import React from 'react';
import {LocationInputs} from '../JobsView.styles';
import {CustomDropdown} from 'epic-ue-ui';
import {Counts} from '../jobs.fetch';
import NativeSelect from '@material-ui/core/NativeSelect/NativeSelect';
import {CarretIcon} from 'epic-ue-ui';

interface Props {
    setLocationFilter: (e: any, filterName: string, value: string) => void;
    jobsFilters?: any;
    counts?: Counts;
    locationLabel?: string;
}

export const LocationDropdown = ({
    setLocationFilter,
    jobsFilters,
    counts,
    locationLabel
}: Props): JSX.Element => {
    const locationTypes = ['Country', 'State', 'City'];
    let hasLocationSelected = false;
    locationTypes.forEach((locationType) => {
        if (jobsFilters[locationType.toLocaleLowerCase()] !== undefined) {
            hasLocationSelected = true;
        }
    });
    return (
        <LocationInputs>
            <CustomDropdown
                label={locationLabel || 'Location'}
                hasCheckedItems={hasLocationSelected}>
                {locationTypes.map((filterName, i) => {
                    //translate state label to "State / Region"
                    let labelName = filterName;
                    if (filterName === 'State') {
                        labelName = 'State / Region';
                    }

                    let disabled = false;
                    //State / City are Disabled unless country selected
                    if (!jobsFilters.country && (filterName === 'State' || filterName === 'City')) {
                        disabled = true;
                    }

                    return (
                        <NativeSelect
                            className="location-select-dropdown"
                            IconComponent={CarretIcon}
                            disabled={disabled}
                            key={i}
                            value={jobsFilters[filterName.toLocaleLowerCase()]}
                            onChange={(e) => {
                                setLocationFilter(
                                    e,
                                    filterName.toLocaleLowerCase(),
                                    e.target.value
                                );
                            }}
                            inputProps={{
                                name: labelName,
                                id: 'uncontrolled-native'
                            }}>
                            <option value="">{labelName}</option>
                            {counts?.[filterName.toLocaleLowerCase()] &&
                                Object.keys(counts?.[filterName.toLocaleLowerCase()]).map(
                                    (keyName, j) =>
                                        keyName.toLocaleLowerCase() === 'blank'
                                            ? ''
                                            : // only show options with >0 results
                                              counts?.[filterName.toLocaleLowerCase()]?.[keyName] >
                                                  0 && (
                                                  <option key={j} value={keyName}>
                                                      {`${keyName} (${
                                                          counts?.[
                                                              filterName.toLocaleLowerCase()
                                                          ]?.[keyName]
                                                      }) `}{' '}
                                                  </option>
                                              )
                                )}
                        </NativeSelect>
                    );
                })}
            </CustomDropdown>
        </LocationInputs>
    );
};
